import React, { useEffect, useState } from "react";
import Button from "onnit-ui/lib/button/Button";
import BuyBoxFooter from "../shared/BuyBoxFooter";
import { useAddToBag } from "../../hooks/useAddToBag";
var ApparelInStockView = function (_a) {
    var product = _a.product, freeShippingThreshold = _a.freeShippingThreshold, onSuccess = _a.onSuccess, onError = _a.onError, addToBagMiddleware = _a.addToBagMiddleware, _b = _a.showFooter, showFooter = _b === void 0 ? true : _b, children = _a.children;
    var _c = useAddToBag({ onSuccess: onSuccess, onError: onError }), isAddingToBag = _c.isAddingToBag, addToBag = _c.addToBag;
    var _d = useState(0), adjustedPrice = _d[0], setAdjustedPrice = _d[1];
    useEffect(function () {
        var adjustedPrice = parseFloat(product.price_raw);
        setAdjustedPrice(adjustedPrice);
    }, [product]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { mt: 5, width: 1, display: "block", disabled: isAddingToBag, onClick: function () {
                var config = {
                    product_id: product.id,
                    quantity: 1,
                    subscription_interval: null,
                };
                if (addToBagMiddleware) {
                    addToBagMiddleware(config)
                        .then(function (newConfig) {
                        addToBag(newConfig);
                    })
                        .catch(console.error);
                }
                else {
                    addToBag(config);
                }
            } }, isAddingToBag ? "Adding..." : "Add to Bag"),
        children,
        showFooter && (React.createElement(BuyBoxFooter, { adjustedPrice: adjustedPrice, freeShippingThreshold: freeShippingThreshold }))));
};
export default ApparelInStockView;
//# sourceMappingURL=ApparelInStockView.js.map